module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vsm-item",
    class: [{
      'open-item': _vm.show
    }, {
      'active-item': _vm.active
    }, {
      'parent-active-item': _vm.childActive
    }]
  }, [(!_vm.item.child) ? [(_vm.isRouterLink) ? [_c('router-link', {
    staticClass: "vsm-link",
    attrs: {
      "to": {
        name: _vm.item.href
      },
      "disabled": _vm.item.disabled,
      "event": _vm.item.disabled ? '' : 'click'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickEvent.apply(null, arguments)
      }
    }
  }, [(_vm.item.icon) ? _c('i', {
    staticClass: "vsm-icon",
    class: _vm.item.icon
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "vsm-title"
  }, [_vm._v(_vm._s(_vm.item.title))])])] : [_c('a', {
    staticClass: "vsm-link",
    attrs: {
      "href": _vm.item.href,
      "disabled": _vm.item.disabled
    },
    on: {
      "click": _vm.clickEvent
    }
  }, [(_vm.item.icon) ? _c('i', {
    staticClass: "vsm-icon",
    class: _vm.item.icon
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "vsm-title"
  }, [_vm._v(_vm._s(_vm.item.title))])])]] : [_c('a', {
    staticClass: "vsm-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleDropdown.apply(null, arguments)
      }
    }
  }, [(_vm.item.icon) ? _c('i', {
    staticClass: "vsm-icon",
    class: _vm.item.icon
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "vsm-title"
  }, [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('i', {
    staticClass: "vsm-arrow",
    class: {
      'open-arrow': _vm.show
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "vsm-dropdown"
  }, [_c('transition', {
    attrs: {
      "name": "show-animation"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "vsm-list"
  }, _vm._l((_vm.item.child), function(subItem, index) {
    return _c('item', {
      key: index,
      attrs: {
        "item": subItem
      }
    })
  }), 1) : _vm._e()])], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d626f78","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/SubItem.vue
// module id = yB/G
// module chunks = 36